<div class="pad-wrapper">
  <canvas #canvas></canvas>

  <yu-button
    color="info"
    type="clear"
    (yuClick)="drawClear()"
  >
    <yu-icon name="eraser"></yu-icon>
  </yu-button>
</div>
